import React from 'react';
import customIcons from './icons';

type VarianceStyle = {
  borderColour: string;
  iconColour: string;
  textTrend: string;
  bgTrend: string;
  icon: React.JSX.Element | null;
};

export default function getVarianceStyle(variance: string, trendUpward?: string): VarianceStyle {
  switch (true) {
    case trendUpward === 'neutral':
      return {
        borderColour: 'border-pipgrey-md',
        iconColour: 'text-pipgrey-md',
        textTrend: 'text-pipgrey-dark',
        bgTrend: 'bg-pipgrey-light',
        icon: null,
      };
    case (variance === '0' || variance === '+0 (+0.0%)'):
      return {
        borderColour: 'border-pipgrey-md',
        iconColour: 'text-pipgrey-md',
        textTrend: 'text-pipgrey-dark',
        bgTrend: 'bg-pipgrey-light',
        icon: customIcons.dashIcon,
      };
    case trendUpward === 'negative' && (variance?.includes('+') || !variance?.includes('-')):
      return {
        borderColour: 'border-pipstatus-error',
        iconColour: 'text-pipstatus-error',
        textTrend: 'text-red-800',
        bgTrend: 'bg-red-100',
        icon: customIcons.trendingUpIcon,
      };
    case trendUpward === 'negative' && variance?.includes('-'):
      return {
        borderColour: 'border-pipstatus-success',
        iconColour: 'text-pipstatus-success',
        textTrend: 'text-primary',
        bgTrend: 'bg-green-100',
        icon: customIcons.trendingDownIcon,
      };
    case variance?.includes('-'):
      return {
        borderColour: 'border-pipstatus-error',
        iconColour: 'text-pipstatus-error',
        textTrend: 'text-red-800',
        bgTrend: 'bg-red-100',
        icon: customIcons.trendingDownIcon,
      };
    case (variance?.includes('+') || !variance?.includes('-')):
      return {
        borderColour: 'border-pipstatus-success',
        iconColour: 'text-pipstatus-success',
        textTrend: 'text-primary',
        bgTrend: 'bg-green-100',
        icon: customIcons.trendingUpIcon,
      };
    default:
      return {
        borderColour: 'border-pipgrey-md',
        iconColour: 'text-pipgrey-md',
        textTrend: 'text-pipgrey-dark',
        bgTrend: 'bg-pipgrey-light',
        icon: customIcons.dashIcon,
      };
  }
}
